import { Component, inject, OnInit } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { LucideAngularModule } from 'lucide-angular';
import { ButtonModule } from 'primeng/button';
import { PageHeaderComponent } from 'src/app/shared/components/page-header/page-header.component';
import { FactorService } from '../../services/factor.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CustomFactor, CustomFactorDto } from '../../types/factor';
import { TooltipIconComponent } from 'src/app/shared/tooltip-icon/tooltip-icon.component';
import { FactorFormDialogComponent } from '../factor-form-dialog/factor-form-dialog.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-manage-factor-page',
  imports: [
    PageHeaderComponent,
    TranslocoPipe,
    LucideAngularModule,
    ButtonModule,
    TooltipIconComponent,
    FactorFormDialogComponent,
    ConfirmDialogModule,
    TooltipModule,
  ],
  templateUrl: './manage-factor-page.component.html',
})
export class ManageFactorPageComponent implements OnInit {
  factorService = inject(FactorService);
  notificationService = inject(NotificationService);
  translocoService = inject(TranslocoService);
  confirmationService = inject(ConfirmationService);
  factors = this.factorService.customFactors;
  dialogVisible = false;
  dialogMode: 'create' | 'edit' = 'create';
  dialogLoading = false;
  selectedFactor?: CustomFactor;

  ngOnInit() {
    this.factorService.loadIfNeeded();
  }

  openCreateDialog() {
    this.selectedFactor = undefined;
    this.dialogMode = 'create';
    this.dialogVisible = true;
  }

  openEditDialog(factor: CustomFactor) {
    this.selectedFactor = factor;
    this.dialogMode = 'edit';
    this.dialogVisible = true;
  }
  confirmDelete(factor: CustomFactor) {
    const header = this.translocoService.translate('factorPage.deleteFactor');
    const message = this.translocoService.translate(
      'factorPage.deleteConfirmation',
    );
    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translocoService.translate('yes'),
      rejectLabel: this.translocoService.translate('no'),
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => this.delete(factor.id),
    });
  }
  delete(id: string) {
    this.factorService.delete(id).subscribe({
      next: () => {
        this.notificationService.success(
          this.translocoService.translate('factorPage.confirmDelete'),
        );
      },
      error: () => {
        this.notificationService.error(
          this.translocoService.translate('factorPage.errorDeletingFactor'),
        );
      },
    });
  }

  submit(factor: CustomFactorDto) {
    this.dialogLoading = true;
    if (this.dialogMode === 'create') {
      this.factorService.create(factor).subscribe({
        next: () => this.closeModal(),
        error: () => this.handleError(),
      });
    } else if (this.dialogMode === 'edit' && this.selectedFactor) {
      this.factorService.update(factor, this.selectedFactor.id).subscribe({
        next: () => this.closeModal(),
        error: () => this.handleError(),
      });
    } else {
      this.handleError();
    }
  }
  private handleError() {
    this.notificationService.error(
      this.translocoService.translate('factorPage.errorSavingFactor'),
    );
    this.closeModal();
  }
  private closeModal() {
    this.dialogVisible = false;
    this.dialogLoading = false;
    this.selectedFactor = undefined;
  }
}
